const v2Flags = ['ps', 'xk'];
var ARFlageIcon = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:[
    'ar-flag',
    ("ar-flag--" + _vm.name),
    _vm.flagVersion
  ],attrs:{"ar-widget-id":"ar-flag-icon","ar-widget-meta":_vm.arWidgetMeta || _vm.computedArWidgetMeta,"name":("ar-flag-" + _vm.name)}})},
staticRenderFns: [],
  name: 'ARFlagIcon',

  props: {
    arWidgetMeta: String,
    name: {
      type: String,
      default: null,
    },
  },
  computed: {
    flagVersion() {
      if (v2Flags.indexOf(this.name) > -1) return 'ar-flag-ver2';
      return 'ar-flag-ver1';
    },
    computedArWidgetMeta() {
      return [
        `name=${this.name};`,
      ].join('');
    },
  },
};

export default ARFlageIcon;
